


































































import Vue from 'vue';
import { OrganisationService } from '@/services/OrganisationService';
import { OrganisationModel } from '@/types/models/organisation';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'ViewOrganisation',
  data() {
    return {
      organisation: {} as OrganisationModel,
      isLoading: false,
      hasError: false,
      errorMessage: ''
    };
  },
  methods: {
    async getOrganisation(this: any) {
      this.isLoading = true;
      OrganisationService.getOrganisationAsync(this.$route.params.id)
        .then((result: any) => {
          this.organisation = result;
          this.organisation.isDeactivated = !this.organisation.isDeactivated;
          this.isLoading = false;
        })
        .catch((error: any) => {
          this.isLoading = false;
          this.hasError = true;
          this.errorMessage = error.notification;
        });
    }
  },
  mounted(this: any) {
    this.getOrganisation();
  },
  components: {
    LoadingSpinner
  }
});
